import React from 'react'
import { fromJS } from 'immutable'
import { actions } from 'react-redux-form/immutable'

import FormContainer from './form-container'

const OfferingsNew = () => (
  <FormContainer />
)

OfferingsNew.onEnter = (store) => () => {
  store.dispatch(actions.change('offeringState.id', 0))
  store.dispatch(actions.change('offeringState.subjects', fromJS([])))
}

export default OfferingsNew



// WEBPACK FOOTER //
// ./src/containers/Setup/Offerings/new.js